export const OpenCesScene = {
  scene_id: 'ucj9tqao4aq2mvbvrl6x', // 可自定义延迟弹窗弹出时间(毫秒)
  delay: 2000,
};
export const TogCesScene = {
  scene_id: 'ucj9tqao4aq2mvbvrl6x',
  delay: 2000,
};
